import type { FaireProductEntity } from "../../entity_types/product";

export const p_9pxyxt9fdp: FaireProductEntity = {
  token: "p_9pxyxt9fdp",
  type: "product",
  name: "CHILD OF GOD | Kids Tee",
  brandToken: "b_nhtve2pux8",
  brandName: "Minimalist Folk Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/18912c3a7cc72705cac5d572692dba7166882ea9e25a34951138881f92a909b0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b8117b48597be0b5aafbdc31d6a32a0b4e24e9aedf1061b20495a965e9b87729.jpeg",
  ],
  priceDollars: 14.25,
  description:
    "WEAR • PLAY • WASH • REPEAT\n\n\n\nIf you have any questions about our sizing, please email us at [redacted-email] for more information.\n",
  tags: [],
  msrpDollars: 28.5,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:18:23.844Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
